import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=70a4a22f"
import script from "./UploadPhoto.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadPhoto.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports